/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integrations_TitleInputs */

const en_ui_integrations_title = /** @type {(inputs: Ui_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

const de_ui_integrations_title = /** @type {(inputs: Ui_Integrations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Ui_Integrations_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integrations_title = /** @type {((inputs?: Ui_Integrations_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integrations_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integrations_title(inputs)
	return de_ui_integrations_title(inputs)
});